const TOKEN_KEY = "auth_token";
const USER_KEY = "auth_user";
const EXPIRES_AT_KEY = "auth_expires_at";
const DEFAULT_SESSION_TTL_MS = 12 * 60 * 60 * 1000;

const isBrowser = () => typeof window !== "undefined";

export const clearSession = () => {
  if (!isBrowser()) return;
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(EXPIRES_AT_KEY);
};

export const setSession = (token, user, ttlMs = DEFAULT_SESSION_TTL_MS) => {
  if (!isBrowser() || !token) return;

  const expiresAt = Date.now() + ttlMs;
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(EXPIRES_AT_KEY, String(expiresAt));

  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
};

export const getSessionToken = () => {
  if (!isBrowser()) return null;

  const expiresAtRaw = localStorage.getItem(EXPIRES_AT_KEY);
  const token = localStorage.getItem(TOKEN_KEY);

  if (!token) return null;

  const expiresAt = Number(expiresAtRaw);
  if (!expiresAt || Date.now() > expiresAt) {
    clearSession();
    return null;
  }

  return token;
};

export const getSessionUser = () => {
  if (!isBrowser()) return null;
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

export const setSessionUser = (user) => {
  if (!isBrowser() || !user) return;
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

